import script from "./ContractSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractSetup.vue?vue&type=script&setup=true&lang=ts"

import "./ContractSetup.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__